
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useEffect } from "react";
import { LoadingScreen } from "@/components/ui/loading-screen";

const CandidateRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { toast } = useToast();
  
  useEffect(() => {
    if (user && user.role !== "candidate") {
      toast({
        title: "Access Denied",
        description: "This area is only for candidates.",
        variant: "destructive",
      });
    }
  }, [user, toast]);

  if (isLoading) {
    return <LoadingScreen message="Loading candidate portal..." />;
  }

  if (!user) {
    return <Navigate to="/candidate-login" state={{ from: location.pathname }} />;
  }

  if (user.role !== "candidate") {
    return <Navigate to="/candidate-login" />;
  }

  return children;
};

export default CandidateRoute;
